var _circle, _path, _circle2, _circle3, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNearPublicTransportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5507 22.4096L59.2494 42.8H21.8759L23.9143 28.2093V28.5H57.0857V27.5H24.0134L24.729 22.3774C25.0396 20.1542 26.941 18.5 29.1857 18.5H52.0896C54.3467 18.5 56.2545 20.172 56.5507 22.4096ZM21.7362 43.8H59.3818L60.0071 48.525C60.7605 54.2171 56.3311 59.2714 50.5893 59.2714H30.4942C24.7248 59.2714 20.2873 54.1709 21.0856 48.457L21.7362 43.8Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 51,
    r: 2,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 51,
    r: 2,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5929 59.4644L23.3 67.1429",
    stroke: "#103B5D",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4071 59.4644L57.7 67.1429",
    stroke: "#103B5D",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57 28H24L22 43H59L57 28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearPublicTransportation);
export default __webpack_public_path__ + "static/media/Near_public_transportation.7ec14b5dffa9a122380f8d7e11cd23da.svg";
export { ForwardRef as ReactComponent };